import { getSiGunGuAccordionId } from './sigunguAccordion'

/**
 * 시군구 그룹으로 부드럽게 스크롤.
 *
 * 입력: 백엔드 SiGunGu.name (한글, 예: "수원시")
 * 매칭 키: `accordion-{sigunguName}` — SiGunGuGroup wrapper 의 id
 *
 * `block: 'start'` + SiGunGuGroup wrapper 의 `scroll-margin-top` 으로 sticky Tabs 바로 아래 일정 gap
 * 위치에 정렬. gap = Tabs 높이(48px) + border 1px + 시각 호흡 20px = 69px.
 * scroll-margin-top 값은 components/SiGunGuGroup/styles.ts 참조.
 *
 * 지도 region.code(행정구역 5자리) → SiGunGu.name 매핑은 호출 측(예: GyeonggiMap)에서 처리.
 */
export function scrollToSiGunGu(sigunguName: string) {
  const el = document.getElementById(getSiGunGuAccordionId(sigunguName))
  el?.scrollIntoView({ behavior: 'smooth', block: 'start' })
}
